import { proxyAPI } from '../httpClient';

export enum KycStatusEnum {
  pending = 'PENDING',
  completed = 'COMPLETED',
}

export type KycStatus = {
  url: string;
  status: KycStatusEnum;
  accountId: string;
  expiresAt: string;
  sessionId: string;
  createdAt: string;
  updatedAt: string;
};

const getKycStatus = async (): Promise<KycStatus> => {
  const response = await proxyAPI.get(
    '/gfh/accounts-verification/accounts/account-verification/status'
  );
  return response.data;
};

export default getKycStatus;
